<!-- user-management.component.html -->
<div class="container user-management">
  <h2 i18n="@@userManagementTitle">User Management</h2>

  <app-user-menu></app-user-menu>

  <p-confirmDialog
    rejectButtonStyleClass="p-button-outlined"
    acceptButtonStyleClass="p-button-danger"
    [header]="'Delete User'"
    i18n-header="@@deleteUserDialogHeader"
    [message]="'Are you sure you want to delete this user?'"
    i18n-message="@@deleteUserDialogMessage"
  >
  </p-confirmDialog>

  <div class="card">
    <div class="p-d-flex p-jc-between p-ai-center p-mb-3 button-container">
      <button pButton label="Create User" i18n-label="@@createUserButton" class="p-button-sm" (click)="openNewAccountModal()"></button>
    </div>

    <p-table
      [value]="accounts"
      [paginator]="true"
      [rows]="pageSize"
      [totalRecords]="totalRecords"
      (onPage)="onPageChange($event)"
      [showCurrentPageReport]="true"
      styleClass="p-datatable-striped p-datatable-sm"
    >

      <ng-template pTemplate="header">
        <tr>

          <th pSortableColumn="firstName" i18n="@@firstNameColumn">
            First Name
            <p-sortIcon field="firstName"></p-sortIcon>
          </th>

          <th pSortableColumn="lastName" i18n="@@lastNameColumn">
            Last Name
            <p-sortIcon field="lastName"></p-sortIcon>
          </th>

          <th pSortableColumn="unit" i18n="@@unitColumn">
            Unit
            <p-sortIcon field="unit"></p-sortIcon>
          </th>

          <th pSortableColumn="phone" i18n="@@phoneColumn">
            Phone #
            <p-sortIcon field="phone"></p-sortIcon>
          </th>

          <th pSortableColumn="callSign" i18n="@@callSignColumn">
            Freq/Call Sign
            <p-sortIcon field="callSign"></p-sortIcon>
          </th>

          <th pSortableColumn="email" i18n="@@emailColumn">
            Email Address
            <p-sortIcon field="email"></p-sortIcon>
          </th>

          <th pSortableColumn="organization.name" i18n="@@organizationColumn">
            Organization
            <p-sortIcon field="organization.name"></p-sortIcon>
          </th>

          <th i18n="@@actionsColumn">
            Actions
          </th>

        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-account>
        <tr>
          <td>{{ account.firstName }}</td>
          <td>{{ account.lastName }}</td>
          <td>{{ account.unit }}</td>
          <td>{{ account.phone }}</td>
          <td>{{ account.callSign }}</td>
          <td>{{ account.email }}</td>
          <td>{{ account.organization?.name }}</td>
          <td>
            <button pButton type="button" class="p-button-text" (click)="editAccount(account)">
              <i class="ri-pencil-fill edit-icon"></i>
            </button>
            <button
              pButton
              type="button"
              class="p-button-text"
              (click)="confirmDelete(account)"
            >
              <i class="ri-delete-bin-fill delete-icon"></i>
            </button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="paginatorleft">
        <span>{{ currentPageReportTemplate }}</span>
      </ng-template>

      <ng-template pTemplate="paginatorright">
        <p-dropdown [options]="pageSizeOptions" [(ngModel)]="pageSize" (onChange)="onPageSizeChange($event)"
          styleClass="p-paginator-rpp-options"></p-dropdown>
      </ng-template>
    </p-table>
  </div>
</div>

<app-user-form-modal
  #userFormModal (save)="onSaveAccount($event)"
  [allRoles]="roles"
  [regions]="regions"
></app-user-form-modal>